/**
 * Single shared color palette for action feedback (confirm dialogs, toasts)
 * and, going forward, tables/forms across the whole app.
 *
 * Adopted from the palette already shared identically across the Master
 * Settings pages (Group/Role/Permission/Module/User/Subscription) — the
 * closest thing to a de-facto standard already in the codebase.
 */
export const ACTION_COLORS_LIGHT = {
  accent: "#b8892c", accentAlt: "#d8b25a", accentSoft: "rgba(184,137,44,0.10)",
  success: "#b8892c", successSoft: "rgba(184,137,44,0.12)",
  error: "#ef4444", errorSoft: "rgba(239,68,68,0.12)",
  warning: "#f59e0b", warningSoft: "rgba(245,158,11,0.12)",
  info: "#8c6a1c", infoSoft: "rgba(140,106,28,0.12)",
  text: "#1d1a14", textSub: "#3f3a32", muted: "#6b6459",
  bg: "#fffcf7", surface: "rgba(255,252,247,0.96)", border: "rgba(184,137,44,0.22)",
};

export const ACTION_COLORS_DARK = {
  accent: "#a78bfa", accentAlt: "#c4b5fd", accentSoft: "rgba(167,139,250,0.16)",
  success: "#34d399", successSoft: "rgba(52,211,153,0.16)",
  error: "#f87171", errorSoft: "rgba(248,113,113,0.16)",
  warning: "#fbbf24", warningSoft: "rgba(251,191,36,0.16)",
  info: "#60a5fa", infoSoft: "rgba(96,165,250,0.16)",
  text: "#e8e9ec", textSub: "#c7cad3", muted: "#a3a8b4",
  bg: "#1a1d26", surface: "rgba(26,29,38,0.95)", border: "rgba(167,139,250,0.22)",
};

/** severity -> color key on the palette above */
export const SEVERITY_COLOR_KEY = {
  add: "success",
  edit: "info",
  delete: "error",
  warning: "warning",
};

export const getActionColors = (isDark) => (isDark ? ACTION_COLORS_DARK : ACTION_COLORS_LIGHT);
